export const iconFontAwesomeFilesFileArrowDown = (
	<i className="fa-solid fa-file-arrow-down"></i>
);
